import { Fragment } from "react/jsx-runtime";
import ConsumerAddFormView from "../../../components/front_office/consumer/ConsumerAddFormView";
import AppURL from "../../../constants/AppURL";
import useFetchData from "../../../helpers/useFetch";

const ConsumerCreateView = () => {
    const { data, loading, error, refetch } = useFetchData(AppURL.FrontOfficeURL + 'front/customer/add/options/list/view/');
    return (
        <Fragment>
            <ConsumerAddFormView data={data} refetch={refetch} loading={loading} error={error} />
        </Fragment>
    )
}

export default ConsumerCreateView;
